import { IResultData } from "@/domain/entities/shared/result";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";

export type IBaseResponse = {
  data?: any;
  resultCode: number;
  resultReason: string;
  resultMessage: string;
};

// export type IResultData = {
//   success: boolean; // 성공여부
//   resultCode: number; // 응답코드
//   errorMessage: string; // 실패 원인
// };

export interface IBaseParser {
  toDomain(data: IBaseResponse): Result<IResultData, ParseError>;
}

@injectable()
export class BaseParser implements IBaseParser {
  toDomain(data: IBaseResponse): Result<IResultData, ParseError> {
    try {
      const resultData: IResultData = {
        isSuccess: data.resultCode === 0,
        resultCode: data.resultCode,
        errorMessage: data.resultMessage,
      };
      return ok(resultData);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
